import type { Currency, OpenExchangeCurrency, OpenExchangeCurrencySymbol } from '../types';

export const CURRENCIES = [
    { code: 'USD', symbol: '$' }, // US Dollar
    { code: 'EUR', symbol: '€' }, // Euro
    { code: 'GBP', symbol: '£' }, // British Pound
    { code: 'AUD', symbol: 'A$' }, // Australian Dollar
    { code: 'CAD', symbol: 'C$' }, // Canadian Dollar
    { code: 'NZD', symbol: 'NZ$' }, // New Zealand Dollar
    { code: 'JPY', symbol: '¥' }, // Japanese Yen
    { code: 'CNY', symbol: '¥' }, // Chinese Yuan
    { code: 'HKD', symbol: 'HK$' }, // Hong Kong Dollar
    { code: 'SGD', symbol: 'S$' }, // Singapore Dollar
    { code: 'KRW', symbol: '₩' }, // South Korean Won
    { code: 'INR', symbol: '₹' }, // Indian Rupee
    { code: 'IDR', symbol: 'Rp' }, // Indonesian Rupiah
    { code: 'THB', symbol: '฿' }, // Thai Baht
    { code: 'MYR', symbol: 'RM' }, // Malaysian Ringgit
    { code: 'PHP', symbol: '₱' }, // Philippine Peso
    { code: 'VND', symbol: '₫' }, // Vietnamese Dong
    { code: 'BRL', symbol: 'R$' }, // Brazilian Real
    { code: 'MXN', symbol: 'MX$' }, // Mexican Peso
    { code: 'ARS', symbol: 'AR$' }, // Argentine Peso
    { code: 'CLP', symbol: 'CLP$' }, // Chilean Peso
    { code: 'COP', symbol: 'COL$' }, // Colombian Peso
    { code: 'PEN', symbol: 'S/' }, // Peruvian Sol
    { code: 'PLN', symbol: 'zł' }, // Polish Zloty
    { code: 'CZK', symbol: 'Kč' }, // Czech Koruna
    { code: 'HUF', symbol: 'Ft' }, // Hungarian Forint
    { code: 'RON', symbol: 'lei' }, // Romanian Leu
    { code: 'BGN', symbol: 'лв' }, // Bulgarian Lev
    { code: 'SEK', symbol: 'kr' }, // Swedish Krona
    { code: 'NOK', symbol: 'kr' }, // Norwegian Krone
    { code: 'DKK', symbol: 'kr' }, // Danish Krone
    { code: 'CHF', symbol: 'CHF' }, // Swiss Franc
    { code: 'ZAR', symbol: 'R' }, // South African Rand
    { code: 'TRY', symbol: '₺' }, // Turkish Lira
    { code: 'AED', symbol: 'د.إ' }, // UAE Dirham
    { code: 'SAR', symbol: '﷼' }, // Saudi Riyal
    { code: 'RUB', symbol: '₽' }, // Russian Ruble
    { code: 'UAH', symbol: '₴' }, // Ukrainian Hryvnia
];

export function getCurrencySymbol(currency: OpenExchangeCurrency | Currency): OpenExchangeCurrencySymbol {
    return CURRENCIES.find(f => f.code === currency)?.symbol as OpenExchangeCurrencySymbol;
}
